import { immerable } from 'immer';
import type { TierDTO, TierState } from '../dto/tier.dto.js';

export class Tier implements TierDTO {
  [immerable] = true;

  _id: string;
  amount: number;
  benefits: string[];
  description: string;
  state: TierState;
  stripePrice: {
    currency: string;
    id: string;
    product: any;
    unit_amount: number | null;
  };
  nbOfSubscribers?: number;
  title: string;

  constructor(data: TierDTO) {
    this._id = data._id.toString();
    this.amount = data.amount;
    this.benefits = data.benefits;
    this.description = data.description;
    this.stripePrice = data.stripePrice;
    this.nbOfSubscribers = data.nbOfSubscribers;
    this.title = data.title;
    this.state = data.state;
  }

  formatPriceWithCurrency(locale: string) {
    return Intl.NumberFormat(locale, {
      style: 'currency',
      currency: this.stripePrice.currency,
    }).format(this.amount);
  }

  get hasSubscribers() {
    return (this.nbOfSubscribers || 0) > 0;
  }

  get isDraft() {
    return this.state === 'draft';
  }

  get isPublished() {
    return this.state === 'published';
  }
}
